import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import PropTypes from 'prop-types';
import { useSession } from '../session/SessionProvider';
import { useSettings } from '../mall_settings/SettingsProvider';

import { mapiHeaders } from './utils';

export const ShippingRatesContext = React.createContext();

export const ShippingRatesProvider = ({ initialAddress, initialQuantity, children }) => {
    const { mapiUrl, orderingToken } = useSettings();
    const { mapiSession } = useSession();
    const [shippingMethods, setMethods] = useState([]);
    const [address, setAddress] = useState(initialAddress);
    const [quantity, setQuantity] = useState(initialQuantity);
    const [isLoading, setIsLoading] = useState(false);
    const [numFetches, setNumFetches] = useState(0);
    const [error, setError] = useState(false);

    const fetchShippingMethods = async () => {
        setError(false);
        const shippingRatesUrl = `${mapiUrl || ''}/capi/mall/shipping/rates/`;
        setIsLoading(true);
        const config = {
            headers: mapiHeaders(orderingToken, mapiSession),
            params: {
                ...address,
                quantity,
                currencyCode: 'USD'
            }
        };

        try {
            const result = await axios.get(shippingRatesUrl, config);
            setMethods(result.data);
        } catch (axiosError) {
            if (error.response) {
                setError(axiosError.response.data);
            } else if (error.request) {
                setError(axiosError.request);
            } else {
                setError(axiosError.toString());
            }
        }
        setNumFetches(numFetches + 1);
        setIsLoading(false);
    };

    useEffect(() => {
        if (typeof address !== 'undefined' && Object.keys(address).length > 0) {
            fetchShippingMethods();
        }
    }, [address, quantity]);

    const doFetch = (newAddress, newQuantity) => {
        setNumFetches(0);
        setAddress(newAddress);
        setQuantity(newQuantity);
    };
    return <ShippingRatesContext.Provider value={{shippingMethods, isLoading, error, doFetch, fetchShippingMethods, numFetches, setAddress, setQuantity}}>{children}</ShippingRatesContext.Provider>;
};

ShippingRatesProvider.defaultProps = {
    initialAddress: undefined,
    initialQuantity: 1
};

ShippingRatesProvider.propTypes = {
    initialAddress: PropTypes.object,
    initialQuantity: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export const useShippingRates = () => useContext(ShippingRatesContext);
